import {translations} from "./variables";

export default class UserValidator {
    constructor() {
        this.invalidProperties = [];
    }

    execute(user, property) {
        switch (property) {
            case 'selectedProjects':
            {
                if (user.isLdap) {
                    const valid = user.selectedProjects.length === 1;
                    this.update(property, valid);
                    break;
                }
                this.update(property, user.hasProjectSelected());
                break;
            }
            case 'usergroups':
            {
                const {valid} = this.validateUsergroups(user);
                this.update(property, valid);
                break;
            }
            case 'privilegegroups':
            {
                const {valid} = this.validatePrivilegegroups(user);
                this.update(property, valid);
                break;
            }
            case 'password':
            case 'passwordConfirmation':
            {
                // no passwords are always valid
                if (!user.password && !user.passwordConfirmation) {
                    this.update('passwords', true);
                    break;
                }
                const samePw = user.password === user.passwordConfirmation;
                const longEnough = user.password.length >= 8 || user.passwordConfirmation.length >= 8;
                const regEx = new RegExp(/^(?=.*[A-Za-z])(?=.*\d).{8,}$/);
                const complexEnough = regEx.test(user.password) && regEx.test(user.passwordConfirmation);
                const valid = samePw && longEnough && complexEnough;
                this.update('passwords', valid);
                break;
            }
            case 'email':
            {
                let valid = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(user.email);

                //external user can have empty email
                if (_.isEmpty(user.email) && user.isExternal) valid = true;

                this.update(property, valid);
                break;
            }
            default:
                const valid = !!user[property];
                this.update(property, valid);
                break;
        }
    }

    update(providedProperty, valid) {
        const exists = this.invalidProperties.some(property => property === providedProperty);
        if (valid && exists) {
            this.invalidProperties = this.invalidProperties.filter(property => property !== providedProperty);
        } else if (!valid && exists) {
            // already invalid - do nothing
        } else if (!valid && !exists) {
            this.invalidProperties.push(providedProperty);
        }
    }

    isInvalid(property) {
        return !!this.getInvalidProperties(property).length;
    }

    getInvalidProperties(property) {
        if (property) {
            const match = this.invalidProperties.find(key => key === property);
            if (match) return [property];
            else return [];
        }
        return this.invalidProperties;
    }

    getDisplayTextForInvalidProperties() {
        return this.invalidProperties.map(propertyKey => {
            return translations[propertyKey] || propertyKey;
        });
    }

    validateGroup(user, groupKey) {
        const projectsWithNoGroup = [];

        user.selectedProjects.forEach(project => {
            if (!project[groupKey].length) {
                projectsWithNoGroup.push(project);
            }
        })

        return {projectsWithNoGroup, valid: !projectsWithNoGroup.length};
    }

    validatePrivilegegroups(user) {
        if (user.isSuperadmin) return {projectsWithNoGroup: [], valid: true};
        return this.validateGroup(user,'privilegegroups');
    }

    validateUsergroups(user) {
        return this.validateGroup(user,'usergroups');
    }
}
